import $ from 'jquery'
import { goalbookUrls } from '../links'

// get user, account, toolkit account, license
export default function getCurrentUser() {
  return $.ajax(`${process.env.VUE_APP_TOOLKIT_URL}/current_user`, {
    type: 'get',
    xhrFields: { withCredentials: true },
  })
}

export function getSSOProviderInfo() {
  return $.ajax(`${goalbookUrls.accounts}/providers`, {
    method: 'GET',
    dataType: 'json',
    xhrFields: { withCredentials: true },
  })
}

export function getAbsorbSAMLResponse() {
  return $.ajax(`${goalbookUrls.auth}/samlresponse/absorb`, {
    method: 'GET',
    xhrFields: { withCredentials: true },
  })
}

export function postSAMLResponseForm(samlResponse) {
  var form = document.createElement('form')
  var samlResponseElement = document.createElement('input')
  form.method = 'POST'
  form.action = `${goalbookUrls.lms}/api/Rest/v2/authentication/saml`
  form.target = '_blank'
  samlResponseElement.type = 'hidden'
  samlResponseElement.value = samlResponse
  samlResponseElement.name = 'samlresponse'
  form.appendChild(samlResponseElement)
  document.body.appendChild(form)
  form.submit()
  form.remove()
}

export async function sendToLMS() {
  var samlResponse = await getAbsorbSAMLResponse()
  postSAMLResponseForm(samlResponse)
}
